import getContainerHeight from './getContainerHeight';

/**
 * Get the CSS style object of the square grid container from the count of items.
 * @param {number} columnCount
 * @param {number} columnGap
 * @param {number} itemCount
 * @param {number} itemSize
 * @param {number} rowGap
 * @returns {object}
 */
const getContainerStyle = (columnCount, columnGap, itemCount, itemSize, rowGap) => {
  return { height: getContainerHeight(columnCount, columnGap, itemCount, itemSize, rowGap) };
};

export default getContainerStyle;
